/**
 *  Member Module
 */

angular
  .module('messages', ['ngResource', 'ngRoute'])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when(CONFIG.url.messages.show(), {
      controller: 'ShowMessageCtrl',
      templateUrl: '/r/static/templates/messages/show.html',
    })
  }])
  .factory('Message', ['$resource', function ($resource) {
    var Message = $resource(
      CONFIG.api('messages'),
      {},
      {
        query: {method: 'POST', isArray: false, params: {id: 'all'}},
      },
    )
    return Message
  }])

/* Controllers */

angular.module('messages').controller('ShowMessageCtrl', ['$scope', 'Message', '$routeParams', function ($scope, Message, $routeParams) {
  $scope.utils.setPageID('msg')
  Message.get(
    {id: $routeParams.id},
    // success handler
    function (data) {
      $scope.msg = data
      $scope.msg_preview = data // for msg-preview.html
      $scope.utils.setPageTitle(data.dst_person_name + ' - ' + _('common_media_' + data.msg_media))
      a4.loaded($scope)
    },
    a4.restErrorFactory($scope),
  )
}])
